module.exports = __webpack_public_path__ + "img/logo2.b19bc555.png";